import { extractPersonFromJsonLd } from './index';
export var extractPersonAssignedTo = function extractPersonAssignedTo(jsonLd) {
  var assignedTo = jsonLd['atlassian:assignedTo'];
  if (assignedTo) {
    return extractPersonFromJsonLd(assignedTo);
  }
};